// src/data/gyms/Elite.js
export const Elite = {
  id: "elite",
  name: "Elite All Stars",
  color: "#7C3AED", // Royal Purple
  lightColor: "#F3E8FF",
  logo: "👑",

  teams: [
    { id: "jglam", name: "J GLAM", level: "L2.2 Junior - PREP" },
    { id: "glittergirls", name: "GLITTER GIRLS", level: "L1.1 Mini - PREP" },
    { id: "paparazzi", name: "PAPARAZZI", level: "L2.1 Senior - PREP" },
    { id: "flawless", name: "FLAWLESS", level: "L1.1 Youth - PREP" },
    { id: "tinytiaras", name: "TINY TIARAS", level: "L1 Tiny - Novice" },
    { id: "royalty", name: "ROYALTY", level: "L3 Junior - Flex - D2" },
    { id: "spotlight", name: "SPOTLIGHT", level: "L1 Junior - Flex - D2" },
    { id: "coedelite", name: "COED ELITE", level: "L4 Senior Open Coed" },
    { id: "fame", name: "FAME", level: "L5 Senior" },
  ],

  schedule: [
    // ================= SATURDAY (Dec 13) =================
    {
      day: "Saturday",
      time: "8:14 AM",
      teamId: "jglam",
      meet: "7:38 AM",
      panel: "Hall A",
    },
    {
      day: "Saturday",
      time: "8:28 AM",
      teamId: "glittergirls",
      meet: "7:52 AM",
      panel: "Hall A",
    },
    {
      day: "Saturday",
      time: "8:45 AM",
      teamId: "paparazzi",
      meet: "8:09 AM",
      panel: "Hall B",
    },
    {
      day: "Saturday",
      time: "10:02 AM",
      teamId: "flawless",
      meet: "9:26 AM",
      panel: "Hall B",
    },
    {
      day: "Saturday",
      time: "10:06 AM",
      teamId: "tinytiaras",
      meet: "9:30 AM",
      panel: "Hall A",
    },
    {
      day: "Saturday",
      time: "12:00 PM",
      teamId: "royalty",
      meet: "11:24 AM",
      panel: "Hall A",
    },
    {
      day: "Saturday",
      time: "2:12 PM",
      teamId: "spotlight",
      meet: "1:36 PM",
      panel: "Hall A",
    },
    {
      day: "Saturday",
      time: "4:12 PM",
      teamId: "coedelite",
      meet: "3:36 PM",
      panel: "Hall A",
    },
    {
      day: "Saturday",
      time: "4:47 PM",
      teamId: "fame",
      meet: "4:11 PM",
      panel: "Hall A",
    },

    // ================= SUNDAY (Dec 14) =================
    // Royalty (Row 160)
    {
      day: "Sunday",
      time: "10:03 AM",
      teamId: "royalty",
      meet: "9:27 AM",
      panel: "Hall A",
    },

    // Spotlight (Row 184)
    {
      day: "Sunday",
      time: "11:53 AM",
      teamId: "spotlight",
      meet: "11:17 AM",
      panel: "Hall A",
    },

    // Coed Elite (Row 217)
    {
      day: "Sunday",
      time: "2:45 PM",
      teamId: "coedelite",
      meet: "2:09 PM",
      panel: "Hall A",
    },

    // Fame (Row 227)
    {
      day: "Sunday",
      time: "3:20 PM",
      teamId: "fame",
      meet: "2:44 PM",
      panel: "Hall A",
    },
  ],
};
